//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { IErrorResponse } from './IErrorResponse';

export class BatchResultItem<T, U extends IErrorResponse> extends ItemBase {
    Success: T | null = null;
    Errors: U[] = [];

    constructor(initializer?: Partial<BatchResultItem<T, U>>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "BatchResultItem";
}
